export default __webpack_public_path__ + "static/images/QR-code-blink-mini-site2.jpg";